import { Button, Modal, Table } from '@maxtropy/components';
import { ColumnsType } from 'antd/es/table';
import type { OperationRecordItem } from '../..';
import styles from './index.module.scss';

interface RecordDetailModalProps {
  open: boolean;
  record?: OperationRecordItem;
  onCancel: () => void;
}

interface DeviceDetailItem {
  id: number;
  device: string;
  suggestedValue: string;
  issuedValue: string;
}

const details: DeviceDetailItem[] = Array.from({ length: 12 }, (_, index) => ({
  id: index + 1,
  device: `DE334331664${index + 1}`,
  suggestedValue: '400.16MW',
  issuedValue: '390.16MW',
}));

const columns: ColumnsType<DeviceDetailItem> = [
  {
    title: '设备',
    dataIndex: 'device',
    width: 230,
  },
  {
    title: '建议值',
    dataIndex: 'suggestedValue',
    width: 220,
  },
  {
    title: '下发值',
    dataIndex: 'issuedValue',
    width: 200,
  },
];

const RecordDetailModal = ({ open, record, onCancel }: RecordDetailModalProps) => (
  <Modal
    title="查看"
    open={open}
    width={720}
    destroyOnClose
    onCancel={onCancel}
    contentClassName={styles.modalContent}
    footer={<Button onClick={onCancel}>关闭</Button>}
  >
    <Table
      className={styles.detailTable}
      rowKey="id"
      columns={columns}
      dataSource={record ? details : []}
      pagination={false}
      scroll={{ y: 440 }}
    />
  </Modal>
);

export default RecordDetailModal;
